<p-dialog [(visible)]="displayDialog"
          [modal]="true"
          [dismissableMask]="true"
          appendTo="body"
          styleClass="si-dialog-small {{dialogClass}}"
          [closable]="closable">
  <div>
    <div class="d-flex">
      <div>
        <i class="{{iconClass}} mr-2"></i>
      </div>
      <div>
        <div class="bold mb-3" *ngIf="headerTitleDialog">
          <div [innerHTML]="headerTitleDialog | translate"></div>
        </div>
        <div>
          <div [innerHTML]="titleDialog | translate"></div>
          <div [innerHTML]="subtitleDialog | translate"></div>
        </div>
      </div>
    </div>
    <div class="si-dialog_buttons-right mt-4">
      <button class="si-button mr-2" (click)="onClickCloseDialog(false)">
        <span translate="{{cancelText}}"></span>
      </button>
      <button class="si-button_main" (click)="onClickCloseDialog(true)">
        <span translate="{{acceptText}}"></span>
      </button>
    </div>
  </div>
</p-dialog>
